import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Header() {
  const { profile, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="flex-between" style={{ maxWidth: 900, margin: '0 auto', height: 56 }}>
        <NavLink to="/" className="logo">
          <img src="/logo.svg" alt="Emotional Intelligence" className="logo-img" />
          EI Music
        </NavLink>
        <nav className="nav-links">
          <NavLink to="/" end>Projects</NavLink>
          <NavLink to="/posts">Posts</NavLink>
          <NavLink to="/chat">Chat</NavLink>
          {profile?.role === 'admin' && (
            <NavLink to="/admin">Dashboard</NavLink>
          )}
          <button onClick={handleLogout}>Logout</button>
        </nav>
      </div>
    </header>
  );
}
